import { browserHelpers } from '@approvalmax/utils';
import { useAtomValue } from 'jotai';
import { selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { memo, useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { useExpandedCompany } from 'shared/hooks';
import { activeCompanyIdState, starterGuideCompaniesState } from 'shared/states';
import { getDefaultPath, getPath, Path } from 'urlBuilder';

export const DefaultRedirectWithStarterGuide = memo(() => {
    const companyId = useAtomValue(activeCompanyIdState);
    const starterGuideCompanies = useAtomValue(starterGuideCompaniesState);
    const activeCompany = useExpandedCompany(companyId);
    const companies = useSelector(selectors.company.companiesSelector);

    const company = !activeCompany && companies.length === 1 ? companies[0] : activeCompany;

    const isGettingStarted = useMemo(
        () => company?.id && starterGuideCompanies.includes(company.id),
        [company?.id, starterGuideCompanies]
    );

    if (browserHelpers.isMobile()) {
        return <Redirect to={getPath(Path.register)} />;
    }

    if (company && isGettingStarted && company?.flags.isManager && company.flags.isTrialLicense) {
        return <Redirect to={getPath(Path.gettingStarted, company.id)} />;
    }

    return <Redirect to={getDefaultPath()} />;
});

DefaultRedirectWithStarterGuide.displayName = 'DefaultRedirectWithStarterGuide';
